import { render, staticRenderFns } from "./PastProjectsTwo.vue?vue&type=template&id=f35d67de&scoped=true"
import script from "./PastProjectsTwo.vue?vue&type=script&lang=js"
export * from "./PastProjectsTwo.vue?vue&type=script&lang=js"
import style0 from "./PastProjectsTwo.vue?vue&type=style&index=0&id=f35d67de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f35d67de",
  null
  
)

export default component.exports